import { useLocalStorageState } from '../../../hooks/useLocalStorage';

export const SHOW_TICKET_ACTIVITY_STORAGE_KEY = 'admin-support-inbox-show-ticket-activity';

export const useSupportTicketActivityVisibility = () =>
	useLocalStorageState<boolean>(SHOW_TICKET_ACTIVITY_STORAGE_KEY, false);
